import { withNamespaces } from "react-i18next";
import { View } from "@react-pdf/renderer";
import ReportContent from "./report";

const groupQuestionsBySection = (questions = []) => {
    const groupedQuestionsBySection = [];

    const findSection = (sectionName) => {
        return groupedQuestionsBySection.find((section) => {
            return section.name === sectionName;
        });
    };

    for (let i = 0; i < questions.length; i++) {
        const question = questions[i];
        let section = findSection(question.section || "");

        if (!section) {
            section = {
                name: question.section || "",
                items: [],
            };
            groupedQuestionsBySection.push(section);
        }

        section.items.push(question);
    }

    return groupedQuestionsBySection;
};

const QuestionnaireReports = ({
    reports = [],
}) => {
    return (
        <View>
            {reports.map((report, index) => {
                return (
                    <ReportContent
                        key={index}
                        sections={groupQuestionsBySection(report)}
                    />
                );
            })}
        </View>
    );
};

export default withNamespaces()(QuestionnaireReports);
